/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'
import type { AreaLabelOption } from '../../index'
import { getQuoteType } from '../../quote/util'

import get from 'lodash/get'
import uniq from 'lodash/uniq'
import { filterByQuoteType } from '../util'

export function getAreaLabelOptions(args: {
  options: OptionsDocument
  quoteType?: string
  inactive?: boolean
  canDeactivate?: boolean
  quote?: QuoteDocument
}): AreaLabelOption[] {
  const { options, inactive, canDeactivate = true } = args
  const { areaTemplates } = options.options
  const quoteType = getQuoteType(args)

  const order =
    areaTemplates.quoteTypeOrder && areaTemplates.quoteTypeOrder[quoteType]
      ? uniq([...areaTemplates.quoteTypeOrder[quoteType], ...areaTemplates.order])
      : areaTemplates.order

  return order
    .map((orderItem) => {
      const item = areaTemplates.values[orderItem]
      if (!item) {
        return null
      }

      let quoteTypes
      if (item.quoteTypes) {
        quoteTypes = item.quoteTypes.filter(Boolean).length > 0 ? item.quoteTypes : ['all']
      } else {
        quoteTypes = [get(item, 'int_ext.value', 'all')]
      }

      const active = typeof item.active === 'undefined' ? true : !!item.active

      const option: AreaLabelOption = {
        name: orderItem,
        label: item.label,
        quoteTypes,
        active
      }

      if (canDeactivate && !inactive && !active) {
        return null
      }

      if (filterByQuoteType({ quoteType, quoteTypes })) {
        return option
      }

      return null
    })
    .filter((item) => item)
}
